import React from 'react'
import { Box } from '@mui/material'
import { advancedColors } from '../theme'

const DashboardCanvas = ({ children }: { children: React.ReactNode }) => (
  <Box sx={{ height: '100%', overflowY: 'auto', backgroundColor: advancedColors.greenSoft }}>
    <Box sx={{ p: { xs: 1.5, md: 2 }, display: 'flex', flexDirection: 'column', gap: 2 }}>{children}</Box>
  </Box>
)

export default DashboardCanvas
